export const hasPermission =  (permiso) => {
  //Inicializar el array con los permisos a vacío.
  let permisos = [];

  //Extraer del localStorage el array con las rutas permitidas y parsearlo para convertir 
  //a un objeto JSON usable.
  if (JSON.parse(localStorage.getItem('permisos'))) {
    permisos = JSON.parse(localStorage.getItem('permisos'));
  };

  //Aplicar un filtro para buscar y extraer la ruta "permiso" entre las rutas guardadas.
  let rutaAuth = permisos.filter(ruta => ruta === permiso);
  
  //Mostrar en consola la ruta encontrada.
  //console.log('esta es la ruta habilitada: ', rutaAuth);

  //En caso de que exista la ruta entre los permisos, retornar un array con esa ruta.
  if (rutaAuth.length > 0) return rutaAuth;

  //En caso de que no exista, retornar nulo.
  else if (rutaAuth.length === 0) return null;

}; 

